import { supabase } from '../lib/supabase';
import { Document } from './documentService';

export interface TranscriptionDocument extends Document {
    type: 'transcription';
    metadata?: {
        duration: number;
        speakerCount?: number;
    };
}

class TranscriptionService {
    /**
     * Save or update a transcription
     * If id is provided, it updates the existing record.
     * If id is not provided, it creates a new one.
     */
    async saveTranscription(
        transcript: any[],
        notes: any,
        duration: number,
        existingId?: string,
        title: string = 'Meeting Transcription'
    ): Promise<string | null> {
        try {
            const { data: { user } } = await supabase.auth.getUser();
            if (!user) throw new Error('User not authenticated');

            const content = JSON.stringify({ transcript, notes });
            const timestamp = new Date().toISOString();

            if (existingId) {
                // Update existing
                const { error } = await supabase
                    .from('documents')
                    .update({
                        content,
                        updated_at: timestamp,
                        metadata: { duration }
                    })
                    .eq('id', existingId);

                if (error) throw error;
                return existingId;
            } else {
                // Create new
                const { data, error } = await supabase
                    .from('documents')
                    .insert({
                        user_id: user.id,
                        title: `${title} - ${new Date().toLocaleDateString()}`,
                        type: 'transcription',
                        content,
                        status: 'draft',
                        created_at: timestamp,
                        updated_at: timestamp,
                        metadata: { duration }
                    })
                    .select('id')
                    .single();

                if (error) throw error;
                return data.id;
            }
        } catch (error) {
            console.error('Error saving transcription:', error);
            return null;
        }
    }
}

export const transcriptionService = new TranscriptionService();
